<template>
    <div>
        <div>
            <progress-header />
        </div>

        <div class="container mt-4">
            <div class="card booking-form-card shadow-sm mt-4">
                <div class="card-header py-3">
                    <span class="icon transfer-type-icon"></span>

                    {{ $t('coaches.transfer_types.pick_type') }}
                </div>

                <form class="bg-white align-content-center py-0"
                    @submit.prevent="handleSubmit"
                >
                    <div class="row px-4">
                        <div class="col-12 col-md-6 col-lg-4" v-for="type in transferTypes" :key="type">
                            <label class="transfer-type-label" :for="'typeCheckbox_' + type">
                                <div class="transfer-type-badge mx-2 mt-4 mb-0 row" :class="{'active': transferType === type}">
                                    <div class="col-2 col-icon d-flex">
                                        <span :class="'align-self-center icon icon-transfer-type-' + type + (transferType === type ? ' active' : '')"></span>
                                    </div>

                                    <div class="col-7 col-text d-flex">
                                        <div class="align-self-center">
                                            {{ $t(`coaches.transfer_types.types.${type}`) }}
                                        </div>
                                    </div>

                                    <div class="col-3 col-check">
                                        <input
                                            :id="'typeCheckbox_' + type"
                                            :checked="transferType === type"
                                            class="form-check-input transfer-type-checkbox"
                                            type="radio"
                                            name="type"
                                            value="sport"
                                            @click="setTransferType(type)"
                                        >

                                        <font-awesome-icon icon="check" color="white" size="lg" class="check-icon" />
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>

                    <div class="row px-4 mt-4" v-if="transferType === 'other'">
                        <div class="col-12">
                            <label for="otherInput">
                                {{ $t('coaches.transfer_types.types.other_specify') }}
                            </label>

                            <div>
                                <textarea
                                    rows="3"
                                    maxlength="255"
                                    id="otherInput"
                                    type="text"
                                    name="other"
                                    class="form-control"
                                    @input="setTransferTypeComment($event)"
                                >{{ transferTypeComment }}</textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row px-4 my-4">
                        <div class="col-12 form-column">
                            <button type="submit" class="btn btn-primary py-2 px-4" :disabled="!transferType">
                                {{ $t('components.coach_search_form.submit') }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import ProgressHeader from './components/ProgressHeader';
    import {mapGetters} from 'vuex';
    export default {
        components: {ProgressHeader},
        data() {
            return {
                query: this.$route.query,
                other: '',
                transferTypes: ['sport', 'school', 'business', 'tourist', 'event', 'other'],
            };
        },

        computed: {
            ...mapGetters({
                transferType: 'coachesOrder/getTransferType',
                transferTypeComment: 'coachesOrder/getTransferTypeComment',
            }),
        },

        methods: {
            setTransferType(type) {
                this.$store.dispatch('coachesOrder/setTransferType', type);
            },

            setTransferTypeComment(event) {
                this.$store.dispatch('coachesOrder/setTransferTypeComment', event.target.value);
            },

            handleSubmit() {
                if (!this.transferType) {
                    return;
                }

                if (this.transferType !== 'other') {
                    this.$store.dispatch('coachesOrder/setTransferTypeComment', null);
                }

                this.$store.dispatch('coachesOrder/setIsTransferTypeComplete', true);
                this.$router.push({name: 'coaches.additional-options', query: this.query});
            },
        },
    };
</script>

<style scoped>
    .transfer-type-badge {
        border: 1px solid rgba(0,70,89,0.1);
        border-radius: 3px;
        background-color: rgba(0,70,89,0.05);
        padding: 8px;
        color: #004659;
    }

    .transfer-type-label {
        width: 100%;
    }

    .transfer-type-badge.active {
        background-color: #004659;
        color: #ffffff;
    }

    .transfer-type-badge .check-icon {
        display: none;
    }

    .transfer-type-badge.active .check-icon {
        display: block;
    }

    .transfer-type-badge .col-icon {
        padding-top: 6px;
    }

    .transfer-type-badge .col-text {
        font-weight: bold;
        font-size: 1.0rem;
        letter-spacing: 0.02rem;
        word-spacing: 100vw;
        min-height: 50px;
    }

    .transfer-type-badge .col-check {
        padding-top: 12px;
    }

    .transfer-type-checkbox {
        display: none;
    }
</style>